import { ProductAttributes } from './models/ProductAttributes'
import { useHttp } from "@/composables/useHttp"

export function useProductHttp() {
  const http = useHttp()

  async function productAttributes(product: number, establishment: string) {
    const url = `products/${product}/product-attributes?establishment_id=${establishment}`

    const attributes = (await http.get(url)).data.data

    return attributes.map((attribute: unknown) => new ProductAttributes(attribute))
  }

  return {
    productAttributes,
  }
}
